import { render, staticRenderFns } from "./Fourth.vue?vue&type=template&id=740f0a26&scoped=true&"
import script from "./Fourth.vue?vue&type=script&lang=js&"
export * from "./Fourth.vue?vue&type=script&lang=js&"
import style0 from "./Fourth.vue?vue&type=style&index=0&id=740f0a26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740f0a26",
  null
  
)

export default component.exports